import { render, staticRenderFns } from "./NewMeatBroadcast.vue?vue&type=template&id=53551321&"
import script from "./NewMeatBroadcast.vue?vue&type=script&lang=js&"
export * from "./NewMeatBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./NewMeatBroadcast.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports